<template>
    <!-- App Header -->
    <HeaderProvince :to="'/'" @change_City_From="changeFrom" @change_City_To="changeTo" />
    <!-- * App Header -->

    <!-- App Capsule -->
    <div id="refresh-container">
        <div style="padding-top: 6rem;">
            <!-- * App Header -->
            <Placeholder v-if="loading" />

            <div v-else style="background-color: white">
                <FixLimited v-if="freeCalls != 'false'" :freeCalls="freeCalls" />

                <div class="section" :class="[
                    { 'mt-3 mb-3': index !== 0 },
                    { 'mt-0 mb-3': index == 0 },
                    { 'pt-45': index == 0 }
                ]" v-for="(cargo, index) in cargos" :key="index.id">

                    <CardView :cargo="cargo" />
                </div>
                <!-- <p class="alert alert-warning text-center" v-if="mode == 0 && loadingOff == 0">
                    لطفا منتظر بمانید...
                </p> -->
                <button @click="nextLoadCargo()" class="btn btn-success btn-block btn-lg"
                    v-if="mode == 1 && loadingNext == 0">
                    نمایش بار های بیشتر کلیک کنید...
                </button>
                <button class="btn btn-warning btn-lg btn-block" type="button" disabled="" v-if="loadingNext == 1">
                    <span class="spinner-border spinner-border-sm me-05" role="status" aria-hidden="true"></span>
                    درحال بارگذاری ...
                </button>
            </div>

            <a href="#" class="button goTop show">
                <ion-icon name="arrow-up-outline"></ion-icon>
            </a>
        </div>
    </div>

    <!-- * App Capsule -->

    <!-- App Bottom Menu -->
    <!-- <Footer v-show="isLoggedIn" /> -->

    <!-- * App Bottom Menu -->

    <!-- App Sidebar -->

    <!-- * App Sidebar -->
</template>
<script>
// import InfiniteScroll from "@/components/cargos/InfiniteScroll";
import Placeholder from "@/components/Placeholder.vue";
import CardView from "@/views/cargo/components/CardView.vue";
import axios from "axios";
import HeaderProvince from "@/components/HeaderSearchProvince.vue";
import PullToRefresh from "pulltorefreshjs";
import Swal from "sweetalert2";
import FixLimited from "@/components/FixLimited.vue";
import router from "@/router";

export default {
    name: "Master",
    components: {
        CardView,
        Placeholder,
        HeaderProvince,
        FixLimited
    },
    data() {
        return {
            from: '',
            to: '',
            mode: 0,
            loadingOff: 0,
            loadingNext: 0,
            results: [],
            cargos: [],
            cityTo: [],
            freeCalls: '',
            cities: {
                from: null,
                to: null
            },
            show: false,
            loading: false,
            location: {
                latitude: null,
                longitude: null,
            },
            axiosConfig: {
                headers: {
                    'Authorization': `Bearer ${window.localStorage.getItem("token")}`,
                    'Accept': 'application/json'
                }
            },
            postData: {
                selectedLoadingCitiesIds: '',
                selectedDischargeCitiesIds: '',
                fleet_id: '',
            },
            ptrInstance: null,
        };
    },
    methods: {
        changeFrom(value) {
            if (value == 0) {
                this.getLocation();
            }
            else {
                this.postData.selectedLoadingCitiesIds = value;
                this.$router.push("/nearLoads?" +
                    'from=' + value + '&' +
                    'to=' + this.postData.selectedDischargeCitiesIds
                );
                this.searchProvince();
            }

        },
        changeTo(value) {
            this.postData.selectedDischargeCitiesIds = value;
            this.$router.push("/nearLoads?" +
                'from=' + this.postData.selectedLoadingCitiesIds + '&' +
                'to=' + value
            );
            this.searchProvince();
        },
        searchProvince() {
            this.loading = true;
            axios.post(`https://core.iran-tarabar.ir/api/requestCitiesList`, this.postData)
                .then((res) => {
                    this.cityTo = res.data.selectedDischargeCitiesIds.map((a) => a.id);
                    this.cityFrom = res.data.selectedLoadingCitiesIds.map((a) => a.id);
                    this.cityTo.forEach((element, index) => {
                        this.cityTo[index] = "\n  " + element;
                    });

                    this.cityFrom.forEach((element, index) => {
                        this.cityFrom[index] = "\n  " + element;
                    });
                    this.cities.from = JSON.stringify(this.cityFrom);
                    this.cities.to = JSON.stringify(this.cityTo);

                    axios.post(`https://core.iran-tarabar.ir/api/driver/searchLoadForDriver`,
                        {
                            selectedLoadingCitiesIds: this.cities.from,
                            selectedDischargeCitiesIds: this.cities.to,
                            fleet_id: this.postData.fleet_id,
                        },
                        this.axiosConfig
                    )
                        .then((response) => {
                            window.scrollTo({
                                top: 0,
                                behavior: 'smooth'
                            });
                            if (response.data.result == 0) {
                                Swal.fire({
                                    position: "center",
                                    icon: "error",
                                    title: response.data.message,
                                    showConfirmButton: true,
                                    confirmButtonText: "تایید",
                                    // timer: 2000,
                                }).then((result) => {
                                    if (result.isConfirmed) {
                                        this.loading = false;
                                        this.cargos = [];
                                    }
                                });
                            } else {
                                response.data.loads.length == 25 ? this.mode = 1 : this.mode = 0;
                                this.loading = false;
                                this.cargos = response.data.loads;
                                setTimeout(() => {
                                    const savedPosition = localStorage.getItem('scrollPosition');
                                    window.scrollTo(0, savedPosition);
                                }, 100);
                                this.show = true;
                            }
                        });
                }).catch((res) => {
                });
        },
        getLocation() {
            this.loading = true;
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(
                    this.showPosition,
                    this.showError
                );
            }
        },
        showPosition(position) {
            this.location.latitude = position.coords.latitude;
            this.location.longitude = position.coords.longitude;
            axios
                .post(
                    `https://core.iran-tarabar.ir/api/driver/searchTheNearestCargo`,
                    {
                        latitude: position.coords.latitude,
                        longitude: position.coords.longitude,
                        lastLoadId: 0
                    }, this.axiosConfig
                )
                .then((response) => {
                    console.log(response.data);
                    this.freeCalls = response.data.freeCalls;
                    this.mode = 1;
                    this.loading = false;
                    this.show = true;
                    this.cargos = response.data.loads;
                    setTimeout(() => {
                        const savedPosition = localStorage.getItem('scrollPosition');
                        window.scrollTo(0, savedPosition);
                    }, 100);
                    this.nextLoadCargo();
                    localStorage.setItem("latitude", position.coords.latitude);
                    localStorage.setItem("longitude", position.coords.longitude);
                    // localStorage.setItem("city", response.data.city);

                    axios.get(
                        `https://api.bigdatacloud.net/data/reverse-geocode-client?latitude=` + position.coords.latitude + `&longitude=` + position.coords.longitude + `&localityLanguage=fa`)
                        .then((response) => {
                            localStorage.setItem("city", response.data.city);
                            axios.put(`https://core.iran-tarabar.ir/api/driver/updateLocation`, {
                                latitude: position.coords.latitude,
                                longitude: position.coords.longitude,
                                city: response.data.city,
                            }, this.axiosConfig).then(() => {
                                //
                            }).catch(() => {
                                //
                            });
                        });
                })
                .catch((error) => {
                    if (error.response.status === 401) {
                        Swal.fire({
                            title: "راننده محترم!",
                            text: "شماره ای که با آن وارد برنامه شده اید، توسط دستگاه دیگری مورد استفاده قرار گرفته است!",
                            icon: "error",
                            confirmButtonColor: "#068b80",
                            confirmButtonText: "ورود مجدد!",
                        }).then((result) => {
                            if (result.isConfirmed) {
                                localStorage.clear();
                                router.push({ name: 'login' })
                            }
                        });

                    }
                });
        },
        nextLoadCargo() {
            this.loadingNext = 1;
            axios
                .post(
                    `https://core.iran-tarabar.ir/api/driver/searchTheNearestCargo`,
                    {
                        latitude: this.location.latitude,
                        longitude: this.location.longitude,
                        lastLoadId: this.cargos[this.cargos.length - 1].id
                    }, this.axiosConfig
                )
                .then((response) => {
                    if (response.data.loads.length == 0) {
                        this.mode = 0;
                        this.loadingOff = 1;
                    }
                    this.cargos.push(...response.data.loads);
                    this.loadingNext = 0;
                })
                .catch(function (error) {
                    // handle error
                    console.log(error);
                });
        },
        showError(error) {
            switch (error.code) {
                case error.PERMISSION_DENIED:
                    alert("لطفا موقعیت مکانی خود را روشن کنید.");
                    break;
                case error.POSITION_UNAVAILABLE:
                    alert("Location information is unavailable.");
                    break;
                case error.TIMEOUT:
                    alert("The request to get user location timed out.");
                    break;
                case error.UNKNOWN_ERROR:
                    alert("An unknown error occurred.");
                    break;
            }
        },
        initPullToRefresh() {
            if (this.ptrInstance) {
                this.ptrInstance.destroy();
            }
            this.ptrInstance = PullToRefresh.init({
                mainElement: '#refresh-container',
                onRefresh: () => this.getLocation()
            });
        },
        saveScrollPosition() {
            localStorage.setItem('scrollPosition', window.scrollY);
        },
    },
    computed: {
        isLoggedIn() {
            return window.localStorage.getItem("token");
        },
    },
    beforeMount() {
        this.getLocation();
    },
    mounted() {
        this.initPullToRefresh();
        // window.addEventListener('beforeunload', this.saveScrollPosition);
    },
    beforeRouteLeave(to, from, next) {
        this.saveScrollPosition();
        next();
    },
    beforeUnmount() {
        if (this.ptrInstance) {
            this.ptrInstance.destroy();
        }
    }
};
</script>
<style>
.pt-45 {
    padding-top: 2rem !important;
}

#webpack-dev-server-client-overlay {
    display: none;
}
</style>